import React, {Fragment} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class MoneyRepositoryForm extends React.Component {

    render() {
        const Form = require("./" + this.props.values.component_type + "Form").default;
        return (
            <Fragment>
                <Form {...this.props} />
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="location"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Helység"
                            />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default createForm(MoneyRepositoryForm);
